import { TagColor as Color } from '@factorialco/deprecated-design-system'
import { StatusVariant } from '@factorialco/f0-react'
import { PerformanceReviewEvaluationStatusEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

const getStatusInfo = (
  evaluationStatus: PerformanceReviewEvaluationStatusEnum
): { color: Color; label: string; statusVariant: StatusVariant } => {
  switch (evaluationStatus) {
    case 'pending':
      return {
        color: Color.grey,
        label: i18n.t('performance_process.reviews.answer_evaluation.answer_status.pending'),
        statusVariant: 'neutral',
      }
    case 'published':
      return {
        color: Color.correct,
        label: i18n.t('performance_process.reviews.answer_evaluation.answer_status.published'),
        statusVariant: 'positive',
      }
  }
}

export const tagColor = (evaluationStatus: PerformanceReviewEvaluationStatusEnum) => {
  const statusInfo = getStatusInfo(evaluationStatus)
  return statusInfo.color
}

export const statusVariant = (evaluationStatus: PerformanceReviewEvaluationStatusEnum) => {
  const statusInfo = getStatusInfo(evaluationStatus)
  return statusInfo.statusVariant
}

export const tagLabel = (
  evaluationStatus: PerformanceReviewEvaluationStatusEnum,
  isRepublishing?: boolean
) => {
  if (isRepublishing) {
    return i18n.t('performance_process.reviews.answer_evaluation.answer_status.editing')
  }

  const statusInfo = getStatusInfo(evaluationStatus)
  return statusInfo.label
}

export const statusColor = (
  status: PerformanceReviewEvaluationStatusEnum,
  isRepublishing?: boolean
): StatusVariant => {
  if (isRepublishing) {
    return 'info'
  }

  const statusColors: Record<PerformanceReviewEvaluationStatusEnum, StatusVariant> = {
    published: 'positive',
    pending: 'neutral',
  }

  return statusColors[status]
}
